export const toggleArrayItem = <T>(arr: T[] | undefined, item: T): T[] => {
  return arr?.includes(item)
    ? arr.filter((i) => i !== item)
    : [...(arr || []), item];
};

export const swapArrayLoc = (arr: string[], from: number, to: number) => {
  let temp = arr[to];
  const newArray = [...arr];
  newArray[to] = arr[from];
  newArray[from] = temp;
  return newArray;
};

export const toggleSetItem = (set: Set<string>, item: string) => {
  if (set.has(item)) return new Set([...set].filter((_item) => _item !== item));
  return new Set([...set, item]);
};

export const convertToObjectsArray = (arrays: any[][], headers?: string[]) => {
  const headersIndexToHeaderMapping = headers?.reduce((acc, headerKey) => {
    acc[headers.indexOf(headerKey)] = headerKey;
    return acc;
  }, {} as Record<number, string>);
  return arrays.map((valuesArray) => {
    const obj: any = {};
    valuesArray.forEach((val, index) => {
      if (headersIndexToHeaderMapping) {
        obj[headersIndexToHeaderMapping[index]] = val;
      }
    });
    return obj;
  });
};

export const findLastNonZeroValue = (array: (number | string)[]) => {
  return (
    array.length -
    array
      .slice()
      .reverse()
      .findIndex((target) => target !== 0)
  );
};
